// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-sm-block{width:250px;display:block}@media screen and (max-width:575px){.btn-sm-block{width:100%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
